import script from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=313e6fa0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313e6fa0"]])

export default __exports__